import script from "./UIJourneyCurrentState.vue?vue&type=script&lang=ts&setup=true"
export * from "./UIJourneyCurrentState.vue?vue&type=script&lang=ts&setup=true"

import "./UIJourneyCurrentState.vue?vue&type=style&index=0&id=5436fb93&lang=stylus&scoped=true"

import exportComponent from "/codebuild/output/src024011243/src/2022-meta-acrossthemetaverse/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5436fb93"]])

export default __exports__